








































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiWorkOrderDetail, apiProcessDispatchSubmit, apiStaffAllList } from '@/api/work_order'
import StaffSelector from '@/components/staff/staff-selector.vue'

@Component({
  components: {
    StaffSelector
  }
})
export default class WorkOrderDispatch extends Vue {
    workOrderId = ''
    workOrderInfo: any = null
    staffList: any[] = []
    staffSelectorVisible = false
    submitting = false

    // 派单表单
    dispatchForm = {
      staff_ids: [] as number[],
      remark: ''
    }

    // 已选择的员工名称列表
    selectedStaffNames: string[] = []

    // 表单验证规则
    dispatchRules = {
      staff_ids: [
        {
          validator: (rule: any, value: any, callback: any) => {
            if (this.dispatchForm.staff_ids.length === 0) {
              callback(new Error('请选择指派员工'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }
      ]
    }

    // 工单类型列表
    orderTypeList: any[] = [
      { value: '1', label: '保洁工单' },
      { value: '2', label: '维修工单' },
      { value: '3', label: '安保工单' },
      { value: '4', label: '接待工单' },
      { value: '5', label: '入住检查' },
      { value: '6', label: '退房检查' },
      { value: '7', label: '设备巡检' },
      { value: '8', label: '绿化维护' }
    ]

    get pageTitle (): string {
      return this.workOrderId ? '派单' : '新增派单'
    }

    // 获取工单类型标签
    getOrderTypeLabel (type: string): string {
      const item = this.orderTypeList.find(item => item.value === type.toString())
      return item ? item.label : '-'
    }

    // 获取紧急程度标签
    getUrgencyLabel (level: number): string {
      const levelMap: any = {
        1: '普通',
        2: '紧急',
        3: '加急'
      }
      return levelMap[level] || '-'
    }

    // 获取紧急程度样式
    getUrgencyType (level: number): string {
      const typeMap: any = {
        1: '',
        2: 'warning',
        3: 'danger'
      }
      return typeMap[level] || ''
    }

    // 获取工单详情
    async getWorkOrderDetail () {
      if (!this.workOrderId) return

      try {
        const res = await apiWorkOrderDetail({ id: this.workOrderId })
        this.workOrderInfo = res
      } catch (error) {
        this.$message.error('获取工单详情失败')
      }
    }

    // 获取员工列表
    async getStaffList () {
      try {
        const res = await apiStaffAllList()
        this.staffList = res.lists || []
      } catch (error) {
        this.$message.error('获取员工列表失败')
      }
    }

    // 打开员工选择器
    openStaffSelector () {
      this.staffSelectorVisible = true
    }

    // 员工选择确认
    handleStaffSelected (staffs: any[]) {
      this.dispatchForm.staff_ids = staffs.map(item => item.id)
      this.selectedStaffNames = staffs.map(item => item.staff_name)
    }

    // 提交派单
    async submitDispatch () {
      try {
        await (this.$refs.dispatchForm as any).validate()

        this.submitting = true

        const params = {
          id: this.workOrderId,
          staff_ids: this.dispatchForm.staff_ids,
          remark: this.dispatchForm.remark
        }

        await apiProcessDispatchSubmit(params)

        // this.$message.success('派单成功')
        this.goBack()
      } catch (error) {
        console.error('派单失败:', error)
      } finally {
        this.submitting = false
      }
    }

    // 返回上一页
    goBack () {
      this.$router.go(-1)
    }

    created () {
      this.workOrderId = this.$route.query.work_order_id as string
      this.getWorkOrderDetail()
      this.getStaffList()
    }
}
